module.exports = __webpack_public_path__ + "img/Renewals-image-banner.ed5227e1.png";